export { default as SideMenu } from './SideMenu/SideMenu.vue'
export { default as TagsView } from './TagsView/TagsView.vue'
export { default as Header } from './header/Header.vue'
